import React, { Fragment } from "react";
import {
	Container,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const DataTextField = styled(TextField)({
	input: {
		color: "#292929",
		"&:-webkit-autofill": {
			WebkitBoxShadow: "0 0 0 1000px #fdfeff inset",
			WebkitTextFillColor: "#292929 !important",
		},
	},
	InputLabelProps: {
		color: "#292929",
		fontFamily: "Quicksand",
	},
	"&:-webkit-autofill": {
		WebkitBoxShadow: "0 0 0 1000px white inset",
	},
	"& label.Mui-focused": {
		color: "#292929",
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#292929",
		},
		"&:hover fieldset": {
			borderColor: "#292929",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#e60b13",
		},
	},
});

const DataSelect = styled(Select)({
	color: "#292929",
	"& fieldset": {
		borderColor: "#292929",
	},
	"&.MuiOutlinedInput-root.Mui-focused": {
		"& fieldset": {
			borderColor: "#e60b13",
		},
	},
});

const AddressDataForm = ({ dataForm, handleChange, states }) => {
	return (
		<Container>
			{dataForm?.map((field, index) => {
				if (field.element === "input") {
					return (
						<Fragment key={field.id}>
							<DataTextField
								id={field?.id}
								name={field?.id}
								type={field?.type}
								label={field?.label}
								onChange={handleChange}
								variant="outlined"
								margin="normal"
								fullWidth
								value={dataForm[index].value}
							/>

							<Typography variant="body1" color="error">
								{dataForm[index]?.error}
							</Typography>
						</Fragment>
					);
				} else {
					return (
						<FormControl sx={{ mt: 2, mb: 1, width: "100%" }} key={field.id}>
							<InputLabel
								className="inputLabel"
								id="stateSelect"
								sx={{
									"&.MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
										color: "#292929",
									},
								}}
							>
								{field.label}
							</InputLabel>
							<DataSelect
								labelId="stateSelect"
								name={field.id}
								value={field.value || ""}
								label="Provincia"
								onChange={handleChange}
								MenuProps={{ style: { maxHeight: "300px" } }}
							>
								{states?.map((state) => {
									return (
										<MenuItem
											key={state.idState}
											name={state.nameState}
											value={state.nameState}
											sx={{ textTransform: "capitalize" }}
										>
											{state.nameState}
										</MenuItem>
									);
								})}
							</DataSelect>
							<Typography variant="body1" color="error">
								{dataForm[index].error}
							</Typography>
						</FormControl>
					);
				}
			})}
		</Container>
	);
};

export default AddressDataForm;
